import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import LandingPage from './components/LandingPage';
import AdminDashboard from './components/AdminDashboard';
import KimoneSellsOrlando from './components/KimoneSellsOrlando';
import awsConfig from './aws-config';
import './App.css';

Amplify.configure(awsConfig);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/kimone-sells-orlando" element={<KimoneSellsOrlando />} />
          <Route
            path="/admin"
            element={
              <Authenticator>
                {({ signOut, user }) => (
                  <AdminDashboard signOut={signOut} user={user} />
                )}
              </Authenticator>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
